<template>
    <div class="main-box">
        <div class="left-box">
            <div class="left-box-header">
                <span>数据源</span>
                <i class="el-icon-plus" @click="showAddDataSource()"></i>
            </div>
            <div class="left-box-tree">
                <el-tree :data="sourceList" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
            </div>
        </div>
        <el-empty v-if="source.c_id==0" style="margin:auto" description="还未创建数据源"></el-empty>
        <div v-else class="right-box">
            <div class="right-box-form">
                <div class="box-title">基本信息
                    <div class="box-title-button">
                        <el-button size="mini" v-if="source.c_type==3" @click="showUpLoadImg()">上传文件</el-button>
                        <el-button size="mini" @click="showEditDataSource()">编辑</el-button>
                        <el-button type="danger" size="mini" @click="deleteDataSource()">删除</el-button>
                    </div>
                </div>
                <div class="right-box-body">
                    <el-empty v-if="source.c_type!=0&&(source.c_url==null||source.c_url=='')" description="无截图" />
                    <img v-else-if="source.c_type!=0" :src="url+source.c_url" height="50%" width="50%"/>
                    <el-form ref="form" :model="source" label-width="80px">
                        <el-form-item label="名称">
                            <div>{{ source.c_name }}</div>
                        </el-form-item>
                        <el-form-item label="类型">
                            <div>{{ getTypeName(source.c_type) }}</div>
                        </el-form-item>
                        <el-form-item label="备注">
                            <div>{{ source.c_desc }}</div>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div v-if="source.c_type!=3" class="right-box-card">
                <div class="box-title">数据表
                    <div class="box-title-button">
                        <el-button size="mini" @click="showEditDataTable()">编辑数据</el-button>
                    </div>
                </div>
                <el-table :data="pieData" style="width: 100%;margin-bottom: 20px;" border>
                    <el-table-column v-for="(item, index) in pieHeaderData" :key="index" :prop="item"
                        :label="item" align="center">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog title="文件上传" :visible.sync="fileUpload" width="30%" >
              <el-form ref="form"  label-width="1.375rem">
                <el-form-item label="">
                  <el-upload class="upload-demo" ref="uploadRef" action="#" :on-change="handleChange"
                    :on-exceed="handleExceed" :multiple="false" :limit="1" :file-list="fileList"
                    :on-success="handSuccess" :auto-upload="false">
                    <el-button slot="trigger" class="button-confrim">选取文件</el-button>
                  </el-upload>
                </el-form-item>
              </el-form>
              <template #footer>
                <el-button class="button-cancel" @click="fileUpload = false">取 消</el-button>
                <el-button class="button-confrim" @click="submitFile">提交</el-button>
              </template>
        </el-dialog>
        <!-- 新增/修改数据源基本信息的弹窗 -->
        <el-dialog :title="infoDialogModel==0?'新增数据源':'编辑数据源信息'" :visible.sync="sourceInfoDialog" width="30%">
            <el-form ref="sourceForm" :model="sourceForm" label-width="80px">
                <el-form-item label="名称">
                    <el-input v-model="sourceForm.c_name"></el-input>
                </el-form-item>
                <el-form-item label="类型" v-if="infoDialogModel == 0">
                    <el-select v-model="sourceForm.c_type" placeholder="请选择">
                        <el-option v-for="item in typeOption" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="sourceForm.c_desc"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeInfoDialog()">取 消</el-button>
                <el-button type="primary" @click="submitInfoDialog()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 编辑数据源数据的弹窗 -->
        <el-dialog :title="'数据编辑: '+source.c_name" :visible.sync="sourceTableDialog" :width="source.c_type==2?'90%':'80%'" :close-on-click-modal="false" :before-close="closeTableDialog">
            <!-- 表格 -->
            <div class="targetTable" v-if="source.c_type==0">
                <div class="targetTable-first">
                    <div class="box-title">编辑表头
                        <!-- <input type="file" ref="uploadExecl" @change="handleExeclChange" accept=".xlsx, .xls"> -->
                    </div>
                    <el-table v-if="tableHeaderLoad" :data="tableHeaderToEdit" style="margin-bottom: 20px;" border height="400">
                        <el-table-column prop="name" label="表头" align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.name" @focus="focusInput" @blur="blurInput"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" width="100" fixed="right" align="center">
                            <template slot="header" slot-scope="scope">
                            <el-button type="primary" size="mini" @click="addHeader">添加</el-button>
                            </template>
                            <template slot-scope="scope">
                                <el-button type="danger" size="mini" @click="deleteHeader(scope.row.name,scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="targetTable-scenod">
                    <div class="box-title">编辑数据</div>
                    <el-empty v-if="tableHeaderToEdit==null||tableHeaderToEdit==[]||tableHeaderToEdit.length==0" description="请先设置表头"></el-empty>
                    <el-table v-else :data="tableToEdit" style="margin-bottom: 20px;" border height="400">
                        <el-table-column v-for="(item,index) in tableHeaderToEdit" :key="index" :prop="item.name" :label="item.name" align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row[item.name]"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" width="100" fixed="right" align="center">
                            <template slot="header" slot-scope="scope">
                                <el-button type="primary" size="mini" @click="addRow">添加</el-button>
                            </template>
                            <template slot-scope="scope">
                                <el-button type="danger" size="mini" @click="deleteRow(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <!-- 饼图 -->
            <div class="targetPie" v-else-if="source.c_type==1">
                <div class="targetPie-first">
                    <div class="box-title">编辑数据</div>
                    <el-table v-if="source.c_type==1" :data="tableToEdit" style="margin-bottom: 20px;" border height="400">
                        <el-table-column prop="name" label="字段名" >
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.name"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="value" label="属性值">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.value"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" width="100" fixed="right">
                            <template slot="header" slot-scope="scope">
                                <el-button type="primary" size="mini" @click="addRow">添加</el-button>
                            </template>
                            <template slot-scope="scope">
                                <el-button type="danger" size="mini" @click="deleteRow(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="targetPie-scenod">
                    <div class="box-title">图表预览</div>
                    <pieChart :intiData="tableToEdit"></pieChart>
                </div>
            </div>
            <!-- 折线 -->
            <div class="targetLine" v-else-if="source.c_type==2">
                <div class="targetLine-first">
                    <div class="box-title">编辑数据项<span style="font-size: 12px;color:rgba(25, 67, 159, 0.795);">提示: 第一项为X轴</span></div>
                    <el-table v-if="tableHeaderLoad" :data="tableHeaderToEdit" style="margin-bottom: 20px;" border height="400">
                        <el-table-column prop="name" label="表头" align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.name" @focus="focusInput" @blur="blurInput"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" width="100" fixed="right" align="center">
                            <template slot="header" slot-scope="scope">
                                <el-button type="primary" size="mini" @click="addHeader">添加</el-button>
                            </template>
                            <template slot-scope="scope">
                                <el-button type="danger" :disabled="scope.$index==0" size="mini" @click="deleteHeader(scope.row.name,scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="targetLine-scenod">
                    <div class="box-title">编辑数据</div>
                    <el-empty v-if="tableHeaderToEdit==null||tableHeaderToEdit==[]||tableHeaderToEdit.length==0" description="请先设置表头"></el-empty>
                    <el-table v-else :data="tableToEdit" style="margin-bottom: 20px;" border height="400">
                        <el-table-column v-for="(item,index) in tableHeaderToEdit" :fixed="index==0" :key="index" :prop="item.name" :label="item.name" align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row[item.name]"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" width="100" fixed="right" align="center">
                            <template slot="header" slot-scope="scope">
                                <el-button type="primary" size="mini" @click="addRow">添加</el-button>
                            </template>
                            <template slot-scope="scope">
                                <el-button type="danger" size="mini" @click="deleteRow(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="targetLine-last">
                    <div class="box-title">图表预览</div>
                    <lineChart :intiData="tableToEdit"></lineChart>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="request">取 消</el-button>
                <el-button type="primary" @click="submitTableDialog()">保 存</el-button>
            </div>
        </el-dialog>
        <!-- 解析execl的弹窗 -->
        <!-- <el-dialog :visible.sync="sourceTableDialog" width="80%" :before-close="closeTableDialog"></el-dialog> -->
        <el-drawer title="数据表生成" :visible.sync="drawer" direction="rtl" size="40%">
            <!-- :before-close="handleClose" -->
            <div class="drawer-box">
                <div class="drawer-body">
                    <div></div>
                    <div v-if="step == 0">
                        <div class="box-title">基本信息</div>
                        <el-form ref="form" :model="dataTableChoice" label-width="80px">
                            <el-form-item label="名称">
                                <el-input v-model="dataTableChoice.name"></el-input>
                            </el-form-item>
                            <el-form-item label="请求方法">
                                <el-input v-model="dataTableChoice.method"></el-input>
                            </el-form-item>
                            <el-form-item label="请求路径">
                                <el-input v-model="dataTableChoice.URL"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <!-- <div>
                        <div class="right-box-form-title">请求参数</div>
                        <div>请求参数</div>
                    </div> -->
                    <div v-if="step == 1">
                        <div class="box-title">数据结构</div>
                        <el-table :data="keyTree" style="width: 100%;margin-bottom: 20px;" row-key="label" border
                            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                            @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="label" label="字段名" width="180"> </el-table-column>
                            <el-table-column prop="name" label="重命名" width="180">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.name"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="type" label="类型" width="180"> </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="step == 1" class="dataPreview">
                        <div class="box-title">数据预览</div>
                        <el-table :data="dataChoice" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
                            <el-table-column v-for="(item, index) in tableLabelList" :key="index" :prop="item.label"
                                :label="item.name" width="180"></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div>
                    <el-button type="primary" v-if="step == 0" @click="nextToGetApi">下一步</el-button>
                    <el-button type="primary" v-if="step == 1" @click="backToGetApi">上一步</el-button>
                    <el-button type="primary" v-if="step == 1" @click="cancel">保存</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import dataSourceApi from "@/api/dataSource";
import pieChart from "./chart/pieChart.vue";
import lineChart from "./chart/line.vue";
import html2canvas from 'html2canvas';
import { TUP, fileUrl, KKFILEURL } from "../../../utils/baseUrl";
import XLSX from 'xlsx'
export default {
    components: { pieChart,lineChart },
    data() {
        return {
            tableHeaderLoad:true,
            // pieHeaderLoad:true,
            // lineHeaderLoad:true,
            tableLabelList: [],
            sourceList: [
                {
                    isP:0,
                    c_name: "表格",
                    children: []
                }, {
                    isP:0,
                    c_name: "饼图",
                    children: []
                }, {
                    isP:0,
                    c_name: "折线图",
                    children: []
                }, {
                    isP:0,
                    c_name: "图片",
                    children: []
                }
            ],
            defaultProps: {
                children: 'children',
                label: 'c_name'
            },
            source: {
                c_id: 0,
                c_name: "",
                c_type: 0,
                c_desc: "",
                c_url: "",
                c_data: "",
                c_data_header:""
            },
            sourceForm: {
                c_id: 0,
                c_name: "",
                c_type: 0,
                c_desc: "",
            },
            drawer: false,
            apiUrl: "http://122.152.198.146:6406/api/getHiveTempData?id=1&min=0&max=0&chooseid=0",
            apiData: undefined,
            keyTree: {},
            dataChoice: undefined,
            step: 0,
            dataTableChoice: {
                name: "test111",
                method: "GET",
                URL: "http://122.152.198.146:6406/api/getHiveTempData?id=1&min=0&max=0&chooseid=0"
            },
            pieData: [],
            pieHeaderData: [],
            pieHeaderData1: [{ label: "name", name: "字段名" }, { label: "value", name: "字段值" }],
            pieHeaderData2: [{ label: "name", name: "字段名" }, { label: "value", name: "字段值" }],
            infoDialogModel: 0,//0新增 1编辑
            sourceInfoDialog: false,
            sourceTableDialog: false,
            tableToEdit: [],
            tableHeaderToEdit: [],
            typeOption: [{ value: 0, label: '表格' }, { value: 1, label: '饼图' }, { value: 2, label: '折线图' }, { value: 3, label: '图片' }],
            choiceId: 1,
            url:fileUrl,
            fileToUp:undefined,
            fileList:[],
            fileUpload:false,
            inputValue:""
        };
    },
    mounted() {
        this.getDataSourceList()
    },
    methods: {
        getDataSourceList() {
            this.sourceList.forEach(source => {
                source.children = []
            })
            dataSourceApi.getDataSourceList().then(res => {
                res.data.data.forEach(element => {
                    if (this.choiceId == element.c_id) {
                        this.handleNodeClick(element)
                    }
                    this.sourceList[element.c_type].children.push(element)
                })
            })
        },
        showAddDataSource() {
            this.infoDialogModel = 0
            this.sourceForm = {
                c_id: 0,
                c_name: "",
                c_type: 0,
                c_desc: "",
            }
            this.sourceInfoDialog = true
        },
        showEditDataSource() {
            this.infoDialogModel = 1
            this.sourceForm = {
                c_id: this.source.c_id,
                c_name: this.source.c_name,
                c_type: this.source.c_type,
                c_desc: this.source.c_desc,
            }
            this.sourceInfoDialog = true
        },
        submitInfoDialog() {
            if (this.infoDialogModel == 0) {//新增
                if (this.sourceForm.c_name == null || this.sourceForm.c_name == "") {
                    this.$message({
                        message: '请填写名称',
                        type: 'warning'
                    });
                }
                dataSourceApi.addDataSource(this.sourceForm).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.getDataSourceList()
                        this.closeInfoDialog()
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                    }
                })
            } else {//修改
                if (this.sourceForm.c_name == null || this.sourceForm.c_name == "") {
                    this.$message({
                        message: '请填写名称',
                        type: 'warning'
                    });
                }
                let data = {
                    c_id: this.sourceForm.c_id,
                    c_name: this.sourceForm.c_name,
                    c_desc: this.sourceForm.c_desc,
                }
                dataSourceApi.editDataSource(data).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.getDataSourceList()
                        this.source = data;
                        this.closeInfoDialog()
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                    }
                })
            }
        },
        closeInfoDialog() {
            this.sourceForm = {
                c_id: 0,
                c_name: "",
                c_type: "",
                c_desc: "",
            }
            this.infoDialogModel = 0
            this.sourceInfoDialog = false
        },
        deleteDataSource() {
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                dataSourceApi.removeDataSource({ c_id: this.source.c_id }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.choiceId = 1
                        this.getDataSourceList()
                    } else {
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        });
                    }
                })
            })
        },
        focusInput(e){
            this.inputValue=e.target.value
        },
        blurInput(e){
            let oldKey = this.inputValue
            let newKey = e.target.value
            let oldData=this.tableToEdit
            let newData=[]
            oldData.forEach(row=>{
                const newObj = {};
                for (let key in row) {
                    if (key === oldKey) {
                        newObj[newKey] = row[key];
                    } else {
                        newObj[key] = row[key];
                    }
                }
                newData.push(newObj)
            })
            this.tableToEdit=newData
        },
        showEditDataTable() {
            this.tableHeaderToEdit = []
            this.tableToEdit = []
            if(this.pieData!=null){
                this.pieData.forEach(row=>{
                    let row1={}
                    var keys = Object.keys(row)
                    keys.forEach(key=>{
                        row1[key]=row[key]
                    })
                    this.tableToEdit.push(row1)
                })
                if(this.source.c_type==0||this.source.c_type==2){
                    var keys = Object.keys(this.pieData[0])
                    for(let i=0;i<keys.length;i++){
                        this.tableHeaderToEdit.push({name:keys[i]})
                    }
                }

            }else{
                if(this.source.c_type==2){
                    this.tableHeaderToEdit.push({name:"x轴"})
                }
            }
            // this.tableHeaderToEdit = this.pieHeaderData
            // this.tableToEdit = this.pieData
            this.tableHeaderLoad=false
            this.$nextTick(()=>{
                this.tableHeaderLoad=true
            })
            this.sourceTableDialog = true
        },
        closeTableDialog(done) {
            this.tableHeaderToEdit = []
            this.tableToEdit = []
            done()
        },
        request() {
            this.tableHeaderToEdit = []
            this.tableToEdit = []
            this.sourceTableDialog = false
            // this.$forceUpdate()
        },
        submitTableDialog() {
            if(this.source.c_type!=0){
                this.submitTableDialogWithPNG()
            }else{
                this.pieData = this.tableToEdit
                let formData = new FormData()
                formData.append("c_id", this.source.c_id)
                formData.append("c_data", JSON.stringify(this.pieData))
                dataSourceApi.editDataSourceData(formData).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.getDataSourceList()
                        this.request()
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                    }
                })
            }
        },
        addRow() {
            if(this.source.c_type==0){
                let row = {}
                this.tableHeaderToEdit.forEach(ele => {
                    row[ele.name] = ""
                })
                this.tableToEdit.push(row)
            }else if(this.source.c_type==1){
                this.tableToEdit.push({name:"",value:""})
            }else if(this.source.c_type==2){
                let row = {}
                this.tableHeaderToEdit.forEach(ele => {
                    row[ele.name] = ""
                })
                this.tableToEdit.push(row)
            }
        },
        deleteRow(index) {
            if(this.source.c_type==0){
                // this.tableHeaderToEdit.push("")
            }else if(this.source.c_type==1){
                // this.tableHeaderToEdit.push("")
            }else if(this.source.c_type==2){
                // this.tableHeaderToEdit.push("")
            }
            this.tableToEdit.splice(index, 1)
        },
        addHeader() {
            if(this.source.c_type==0){
                // if(this.tableToEdit!=null&&this.tableToEdit!=[]){
                //     this.tableToEdit.forEach(row=>{
                //         row["newWord"]=""
                //     })
                // }
                this.tableHeaderToEdit.push({name:""})
            }else if(this.source.c_type==1){
                this.tableHeaderToEdit.push("")
            }else if(this.source.c_type==2){
                this.tableHeaderToEdit.push({name:""})
            }

        },
        deleteHeader(key,index) {
            if(this.source.c_type==0){
                if(this.tableToEdit!=null&&this.tableToEdit!=[]){
                    this.tableToEdit.forEach(row=>{
                        Reflect.deleteProperty(row,key)
                    })
                }
                this.tableHeaderToEdit.splice(index, 1)
            }else if(this.source.c_type==1){
                if(this.tableToEdit!=null&&this.tableToEdit!=[]){
                    this.tableToEdit.forEach(row=>{
                        Reflect.deleteProperty(row,key)
                    })
                }
                this.tableHeaderToEdit.splice(index, 1)
            }else if(this.source.c_type==2){
                if(this.tableToEdit!=null&&this.tableToEdit!=[]){
                    this.tableToEdit.forEach(row=>{
                        row[key]=undefined
                        delete row[key]
                    })
                }
                this.tableHeaderToEdit.splice(index, 1)
            }
        },
        handleExeclChange(event) {
            const file = event.target.files[0];
            if (!file) {
                return;
            }
            var XLSX = require("xlsx");
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = e.target.result;
                const Workbook = XLSX.read(data, { type: 'binary'}); // 通过XLSX读取出来得到了一个 workdata 对象
                let tableData = XLSX.utils.sheet_to_json(Workbook.Sheets[Workbook.SheetNames])
                let keys = Object.keys(tableData[0])
                this.tableToEdit=[]
                this.tableHeaderToEdit=[]
                for(let i=0;i<keys.length;i++){
                    this.tableHeaderToEdit.push({name:keys[i]})
                }
                this.tableToEdit=tableData
            };
            reader.readAsArrayBuffer(file);
            this.$refs.uploadExecl.value = '';
        },
        inputHeader(key){
            // if(this.tableToEdit!=null&&this.tableToEdit!=[]){
            //     this.tableToEdit.forEach(row=>{
            //         Reflect.deleteProperty(row,key)
            //     })
            // }
        },
        handleClose() { },
        backToGetApi() {
            this.step = 0
        },
        cancel() {
            this.drawer = false
        },
        showDarwer() {
            this.drawer = true
        },
        nextToGetApi() {
            dataSourceApi.getApiData({ api: this.apiUrl }).then((res) => {
                this.apiData = res.data.data.list
                this.keyTree = res.data.data.keyTree.children
                this.step = 1
            })
        },
        handleSelectionChange(selection) {
            this.dataChoice = []
            this.tableLabelList = []
            let keyValueList = {}
            selection.forEach(element => {
                let label = element.label
                this.tableLabelList.push({
                    name: element.name,
                    label: element.label
                })
                for (var i = 0; i < this.apiData.length; i++) {
                    var key = this.apiData[i].label;
                    if (key == label) {
                        if (element.type == 3 || element.type == 4) keyValueList[key] = this.apiData[i].data
                        else keyValueList[key] = [this.apiData[i].data]
                    }
                }
            });
            this.dataChoice = []
            var valueListKeys = Object.keys(keyValueList)
            // let dataList=[]
            for (var i = 0; i < 10; i++) {
                let dataChoiceItem = {}
                for (var j = 0; j < valueListKeys.length; j++) {
                    var key = valueListKeys[j];
                    dataChoiceItem[key] = keyValueList[key][i] == undefined ? null : keyValueList[key][i]
                }
                this.dataChoice.push(dataChoiceItem)
            }
        },
        handleNodeClick(data) {
            if(data.isP!=undefined){
                return
            }
            this.pieData = []
            this.pieHeaderData = []
            this.source = data
            if (data.c_data != null && data.c_data != ""&&data.c_data != "[]") {
                this.pieData = JSON.parse(data.c_data)
                if(this.source.c_type==0){
                    var keys = Object.keys(this.pieData[0])
                    for(let i=0;i<keys.length;i++){
                        this.pieHeaderData.push(keys[i])
                    }
                } else if(this.source.c_type==1){
                    this.pieHeaderData=["name","value"]
                }else if(this.source.c_type==2){
                    var keys = Object.keys(this.pieData[0])
                    for(let i=0;i<keys.length;i++){
                        this.pieHeaderData.push(keys[i])
                    }
                }
            } else {
                this.pieData = null
                this.pieHeaderData = null
            }
            this.choiceId = this.source.c_id
        },
        getTypeName(e) {
            if (e == 0) {
                return "表格"
            } else if (e == 1) {
                return "饼图"
            } else if (e == 2) {
                return "折线图"
            } else if (e == 3) {
                return "图片"
            }
        },
        handleChange(file, fileList){
          this.fileToUp = file;
        },
        handSuccess(response, file, fileList){
          this.$refs.uploadRef.clearFiles()
        },
        handleExceed(files, uploadFiles) {
          this.fileList = []
          let item = files[0]
          let file = {
            name: item.name,
            percentage: 0,
            raw: item,
            size: item.size,
            status: "ready",
            uid: genFileId()
          }
          this.fileToUp = file;
          this.fileList.push(file)
          // this.fileToUp = files[0];
        },
        //上传文件
        submitFile() {
            if (this.fileToUp == undefined) {
              ElMessage({
                message: "请先选择文件",
                type: "warning",
              });
            }
            let formData = new FormData()
            formData.append("c_id", this.source.c_id)
            formData.append("file",this.fileToUp.raw)
            dataSourceApi.uploadDataSourceFile(formData).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    this.getDataSourceList()
                    this.fileUpload=false
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'success'
                    });
                }
            })
        },
        showUpLoadImg(){
          this.fileToUp = undefined;
          this.fileUpload = true;
          // uploadRef.value.clearFiles()
        },
        submitTableDialogWithPNG() {
            let imgId = this.source.c_type==1?"pieChart":"linChart"
            var target = document.getElementById(imgId);
            html2canvas(target).then(canvas => {//生成图片
                var ctx = canvas.getContext('2d');
                var img = new Image();
                img.src = canvas.toDataURL('image/png');
                // img.onload = function () {
                //     var screenshot = document.getElementById('screenshot');
                //     screenshot.src = img.src;
                // };
                this.pieData = this.tableToEdit
                let file = this.dataURLtoFile(img.src,new Date().getTime()+'_screen.png')
                let formData = new FormData()
                formData.append("c_id", this.source.c_id)
                formData.append("c_data", JSON.stringify(this.pieData))
                formData.append("file",file)
                dataSourceApi.uploadDataSourceFile(formData).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.getDataSourceList()
                        this.request()
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                    }
                })
            });
        },
        //图片
        dataURLtoFile(dataurl, filename) {
        	let arr = dataurl.split(',');
        	let mime = arr[0].match(/:(.*?);/)[1];
        	let bstr = atob(arr[1]);
        	let n = bstr.length;
        	let u8arr = new Uint8Array(n);
        	while (n--) {
        		u8arr[n] = bstr.charCodeAt(n);
        	}
        	return new File([u8arr], filename, {
        		type: mime
        	});
        }
    }
};
</script>

<style lang="css" scoped>
.main-box {
    width: 100vw;
    height: 93vh;
    display: flex;
    overflow: hidden;
}

.left-box {
    width: 18vw;
    height: 86vh;
    padding: 4vh 4vh;
    border-right: rgba(0, 0, 0, 0.8) solid 0.1rem;
    background-color: #fff;
}

.left-box-header {
    height: 10vh;
    display: flex;
    padding: 1vh;
    justify-content: space-between;
}

.left-box-tree {
    height: 92vh;
}

.right-box {
    width: 80vw;
    height: 100vh;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;
}

.right-box-form {
    width: 50%;
    margin-top: 5%;
}

.box-title {
    border-left: #3294fe 2px solid;
    padding-left: 4px;
    margin: 10px 0;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: end;
}
.right-box-body{
    display: flex;
    flex-direction: row;
}
.right-box-card {
    width: 50%;
}

.card {
    margin-top: 20px;
}

.drawer-box {
    /* height: 50vh; */
    padding: 10px;

    .drawer-body {
        height: 84vh;
        overflow-y: scroll;

        .dataPreview {
            .el-table__footer-wrapper
            {
                overflow-x: scroll;
            }

        }
    }
}
.targetTable{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}
    .targetTable-first{
        width: 30%;
    }
    .targetTable-scenod{
        width: 60%;
    }
.targetPie{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}
    .targetPie-first{
        width: 45%;
    }
    .targetPie-scenod{
        width: 40%;
    }
.targetLine{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}
    .targetLine-first{
        width: 16%;
    }
    .targetLine-scenod{
        width: 40%;
    }
    .targetLine-last{
        width: 40%;
    }
</style>



// WEBPACK FOOTER //
// src/components/dataSource/dataSource.vue